/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EventEmitter, Injectable } from '@angular/core';
import { CheckboxTreeNode } from './checkbox-tree-node';

@Injectable()
export class CheckboxTreeService {
  change = new EventEmitter<CheckboxTreeNode<any>>();
}
